module.exports = __webpack_public_path__ + "img/fs1.589ea0ce.gif";